import React, { ReactNode } from "react";

const CALLOUT_TITLE = {
  info: "Info",
  tip: "Pro tip",
  warning: "Heads up",
  success: "Done right",
  danger: "Caution",
  note: "Note",
};

interface CalloutProps {
  type?: "info" | "tip" | "warning" | "success" | "danger" | "note";
  title?: string;
  children: ReactNode;
}

export const Callout: React.FC<CalloutProps> = ({
  type = "info",
  title,
  children,
}) => {
  const t = title ?? CALLOUT_TITLE[type];

  return (
    <div className={`callout callout--${type}`}>
      <div className="callout__body">
        {t && <h4 className="callout__title">{t}</h4>}
        <div className="callout__content">{children}</div>
      </div>
    </div>
  );
};
